import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import VoiceMultiSelectFilter from './VoiceMultiSelectFilter';

const NO_DEPARTMENT_VALUE = 'none';

// ENG-2768: Department filter for the Voice Inbox.
// - Admins: all org departments + a "No department" option (logs missing
//   department_id).
// - Non-admin users: only their own departments.
// The parent hides this filter when there are no departments to choose from.
// Owns option-building; delegates the multi-select markup to VoiceMultiSelectFilter.
const DepartmentFilter = ({
  updateQuery,
  selectedDepartment,
  setSelectedDepartment,
  departments,
  showNoDepartmentOption,
}) => {
  const options = departments.map((dept) => ({
    label: dept.name,
    value: dept.slug,
  }));

  if (showNoDepartmentOption) {
    options.push({ label: 'No department', value: NO_DEPARTMENT_VALUE });
  }

  return (
    <VoiceMultiSelectFilter
      updateQuery={updateQuery}
      queryKey="department_id"
      placeholder="Department"
      value={selectedDepartment}
      setValue={setSelectedDepartment}
      options={options}
      minWidth="180px"
      selectionType="departments"
    />
  );
};

DepartmentFilter.defaultProps = {
  updateQuery: () => {},
  selectedDepartment: [],
  setSelectedDepartment: () => {},
  departments: [],
  showNoDepartmentOption: false,
};

DepartmentFilter.propTypes = {
  updateQuery: PropTypes.func,
  selectedDepartment: PropTypes.arrayOf(PropTypes.string),
  setSelectedDepartment: PropTypes.func,
  departments: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    slug: PropTypes.string,
  })),
  showNoDepartmentOption: PropTypes.bool,
};

export default withRouter(DepartmentFilter);
